import {
  initialState,
  Actions,
  State,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_ERROR,
  RESET_DELETE_CUSTOMER,
} from '../../types/customer/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CUSTOMER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_CUSTOMER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_CUSTOMER:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
